module.exports = __webpack_public_path__ + "img/bg29.df633fba.png";